import React from "react";
import { Outlet } from "react-router-dom";

const Destination: React.FC = () => {
  return <Outlet />;
};

export default Destination;